<template>
    <div class="mb-8 w-full lg:flex-initial lg:w-1/4 lg:mb-8 lg:px-4">
        <ShcUiParagraph class="uppercase font-semibold mb-5">
            {{ title }}
        </ShcUiParagraph>

        <ShcUiParagraph theme="secondary">{{ street }}, {{ zip }} {{ city }}</ShcUiParagraph>
        <ShcUiParagraph theme="secondary">{{ phone }}</ShcUiParagraph>

        <div v-if="isOpen">
            <ShcUiParagraph theme="secondary">
                <span v-html="description"></span>
            </ShcUiParagraph>

            <ShcUiParagraph theme="secondary">
                {{ $t('Bbk.storeLocatorPoint.moFr') }} {{ openTime.openMoFr }} - {{ openTime.closeMoFr }}
            </ShcUiParagraph>
            <ShcUiParagraph theme="secondary">
                {{ $t('Bbk.storeLocatorPoint.sa') }} {{ openTime.openSa }} - {{ openTime.closeSa }}
            </ShcUiParagraph>
            <ShcUiParagraph theme="secondary">
                {{ $t('Bbk.storeLocatorPoint.sn') }} {{ openTime.openSn }} - {{ openTime.closeSn }}
            </ShcUiParagraph>
        </div>

        <ShcUiParagraph
            theme="tertiary"
            class="font-normal underline cursor-pointer text-right mt-4 mb-8"
            @click="toggleOpen"
        >
            <span v-if="!isOpen"> {{ $t('Bbk.storeLocatorPoint.showMore') }} </span>
            <span v-if="isOpen"> {{ $t('Bbk.storeLocatorPoint.showLess') }} </span>
        </ShcUiParagraph>

        <ShcUiButton
            :theme="BUTTON_THEME.white"
            class="w-full text-normal font-semibold uppercase mb-8"
            @click="moveMapToPoint(latitude, longitude)"
        >
            {{ $t('Bbk.storeLocatorPoint.showOnMap') }}
        </ShcUiButton>

        <hr class="w-1/4 border-black lg:hidden" />
    </div>
</template>

<script lang="ts" setup>
    import type { Props } from './props'
    import { BUTTON_THEME } from '@shc/nuxt-shc-ui-layer/components/Button/button'

    const props = defineProps<Props>()
    const { $bus } = useNuxtApp()

    let isOpen = ref(false)

    function toggleOpen() {
        isOpen.value = !isOpen.value
    }

    function moveMapToPoint(lat: number, lng: number) {
        $bus.$emit('moveMapToPoint', { lat: lat, lng: lng })
    }
</script>
